<template>
    <div class="WorkWithUs">
        <div class="pageContent">
            <TopLogoBar logoColor="black" textColor="#000" title="Lavora con noi" />
            <div class="container infoContainer">
                <div class="columns is-multiline">
                    <div class="column is-6">
                        <p class="descriptionText">
                            La storia di page93® è quella di tre imprenditori del mondo
                            dell’informatica: <b><span class="mark">Graziella</span> Bordone</b>, <b><span
                                    class="mark">Roberto</span> Molino</b>, <b><span class="mark">Giorgio</span>
                                Vacchetto</b> e
                            ma è anche la storia di tutti noi, di
                            un’evoluzione durata venticinque anni, unica e irripetibile.
                            E’ una storia di passioni, di viaggi, di vino e di sport, e poi di
                            computer e di programmi che aiutano le aziende a crescere
                            e migliorarsi.<br><br>
                            <b>Questa storia comincia in un garage nel <span class="mark">1993</span> .</b><br>
                            Molino, Vacchetto e Bordone si incontrano per la prima
                            volta in Orma, una società piemontese che, nei primi anni
                            ‘80, comincia a commercializzare computer Olivetti. Dopo
                            Orma, Computerlandia, e dopo ancora, nel 1993, nasce
                            Package Azienda. Dopo Olivetti, il garage e dopo il garage
                            due sedi, una ad Alba e una ad Asti con tre soci, quindici
                            collaboratori e quattrocento clienti.<br><br>
                        </p>
                    </div>
                    <div class="column is-6">
                        <p class="descriptionText">
                            <b>Oggi Package Azienda è diventata <span class="mark">page93®</span>.</b><br>
                            In occasione del suo 25° compleanno Package Azienda diventa page93®.
                            Quelli che nel 1993 erano pacchetti informatici per tutti, oggi
                            per l’utente finale i programmi gestionali sono diventate
                            “semplici” pagine di dialogo.<br><br>
                            <b>page93® rinnova il suo aspetto.</b><br>
                            Ristrutturando nel 2019 gli uffici della sede di Alba, in Corso Piera Cillario 6/8. Ma
                            l’innovazione non si ferma qui e il progetto di <span class="mark">crescita
                                organizzativa</span>, già avviato nella
                            fase di studio, prevede l’ampliamento della struttura in tutte le sue declinazioni: parte
                            dell’edificio adiacente la sede aziendale e di recente acquisizione di Page93®, storicamente
                            noto ad Alba con il nome di “Martinetto”, verrà adibito ad ufficio.<br><br>
                        </p>
                    </div>
                    <div class="column is-6 is-offset-3">
                        <p class="descriptionText">
                            La crescita multidirezionale di Page93®, veicolata dall’ambizione imprenditoriale dei soci e
                            dalla domanda di mercato, passa imprescindibilmente attraverso le <span
                                class="mark">persone</span>:<br>
                            <b>CAMBIA PAGINA, <span class="mark">LAVORA CON NOI</span></b>
                        </p>
                    </div>
                </div>
                <img src="@/assets/images/icons/peopleIcon.png" class="peopleIcon">
            </div>
        </div>
        <div class="pageContent blackBg">
            <div class="container infoContainer">
                <div class="descriptionText workContainer">
                    <div class="has-text-centered">
                        <b class="bRed"><span>CONSULENTE TECNICO HELP DESK</span></b>
                        <p style="font-size: 22px;">Per software gestionali, web app e Mago</p>
                    </div>
                    <br><br>
                    <div class="columns is-multiline">
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/profileIcon.png"
                                    width="35px" class="iconInfo">Profilo professionale</h3>
                            <p>
                                Diploma di ragioneria e/o Laurea in informatica/economia.<br>

                                Precedente esperienza lavorativa analoga,
                                anche breve.<br><br>

                                Si ricerca una <span class="mark">persona</span> che abbia una propensione spiccata al
                                <i>problem
                                    solving</i> e che
                                apprezzi lavorare a contatto e a supporto del cliente a 360°.<br>
                                La passione e la voglia di mettersi in gioco sono caratteristiche auspicate.<br><br>

                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/gearIcon.png"
                                    width="35px" class="iconInfo">Posizione di Lavoro</h3>
                            <p>
                                Si ricerca un <span class="mark">tecnico</span> addetto all’help-desk per software
                                gestionali e web app ai fini di
                                ampliare un team già esistente.<br><br>
                                Dopo un periodo di training della durata variabile il candidato sarà inserito nel team
                                che si occupa di fornire supporto al cliente nella fruizione di software sviluppati da
                                page93® e/o al <span class="mark">gestionale</span> Mago di Microarea Zucchetti.<br><br>
                            </p>
                        </div>

                        <div class="column is-12 circleWorkImageContainer">
                            <img src="@/assets/images/icons/circleWork.png" class="circleWork">
                        </div>
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/winIcon.png"
                                    width="35px" class="iconInfo">Perchè con page93®</h3>
                            <p>La ricerca è finalizzata all’inserimento a tempo <span class="mark">indeterminato</span>
                                mentre l’inquadramento
                                proposto sarà commisurato alle competenze ed all’esperienza della risorsa.<br><br>

                                Orario di lavoro <span class="mark">flessibile</span><br>
                                Corsi di <span class="mark">formazione</span> continua<br>
                                Possibilità di <span class="mark">crescita</span> all’interno di page93®<br>
                                <span class="mark">Benefit</span> da concordare ad hoc<br><br>
                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/workIcon.png"
                                    width="35px" class="iconInfo">Sede di lavoro</h3>
                            <p>
                                La sede di lavoro è situata in<br>
                                Corso Piera Cillario 6/8 – <span class="mark">Alba</span> (CN) – 12051<br><br>
                            </p>
                        </div>
                    </div>

                    <b class="bRed"><span>PROGRAMMATORE JAVA - SVILUPPATORE WEB APP</span></b>
                    <br><br>
                    <div class="columns is-multiline">
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/profileIcon.png"
                                    width="35px" class="iconInfo">Profilo professionale</h3>
                            <p>
                                Diploma di perito informatico e/o Laurea in informatica e/o Ingegneria
                                Informatica.<br><br>


                                Si ricerca una <span class="mark">persona</span> che abbia solide competenze hard in
                                ambito di sviluppo web nel
                                linguaggio java nonché conoscenza approfondita degli ambienti di sviluppo Microsoft
                                Visual Studio, C#, VB.NET, ASP.NET, PHP.<br><br>

                                Agilità operativa e di pensiero, propensione al <i>problem solving</i> sono
                                caratteristiche
                                ricercate.<br><br>
                                Non è necessaria pregressa esperienza lavorativa.<br><br>
                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/gearIcon.png"
                                    width="35px" class="iconInfo">Posizione di Lavoro</h3>
                            <p>
                                Si ricerca un <span class="mark">programmatore java</span> addetto allo sviluppo di
                                applicazioni web app ai fini
                                di ampliare un team già esistente.<br><br>

                                Dopo un periodo di training della durata variabile il candidato sarà inserito nel <span
                                    class="mark">team</span>
                                che si occupa di sviluppare web app realizzate da page93®.<br><br>

                            </p>
                        </div>

                        <div class="column is-12 circleWorkImageContainer">
                            <img src="@/assets/images/icons/circleWork.png" class="circleWork">
                        </div>
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/winIcon.png"
                                    width="35px" class="iconInfo">Perchè con page93®</h3>
                            <p>La ricerca è finalizzata all’inserimento a tempo <span class="mark">indeterminato</span>
                                mentre l’inquadramento
                                proposto sarà commisurato alle competenze ed all’esperienza della risorsa.<br><br>

                                Orario di lavoro <span class="mark">flessibile</span><br>
                                Corsi di <span class="mark">formazione</span> continua<br>
                                Possibilità di <span class="mark">crescita</span> all’interno di page93®<br>
                                <span class="mark">Benefit</span> da concordare ad hoc<br><br>
                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/workIcon.png"
                                    width="35px" class="iconInfo">Sede di lavoro</h3>
                            <p>
                                La sede di lavoro è situata in<br>
                                Corso Piera Cillario 6/8 – <span class="mark">Alba</span> (CN) – 12051<br><br>
                            </p>
                        </div>
                    </div>

                    <b class="bRed"><span>SALES ACCOUNT</span></b>
                    <br><br>
                    <div class="columns is-multiline">
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/profileIcon.png"
                                    width="35px" class="iconInfo">Profilo professionale</h3>
                            <p>
                                Diploma e/o Laurea.<br><br>

                                Si ricerca una <span class="mark">persona</span> che abbia solide competenze soft:
                                ottime doti comunicative e
                                propensione alle relazioni. <br><br>

                                Si ricerca competenza dei processi aziendali. L’esperienza lavorativa pregressa,
                                preferibilmente superiore all’anno, è gradita.<br><br>

                                Buono conoscenza della lingua <span class="mark">inglese</span> e/o francese sia scritta
                                sia orale.<br><br>

                                Flessibilità e capacità di gestione dello stress.<br><br>

                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/gearIcon.png"
                                    width="35px" class="iconInfo">Posizione di Lavoro</h3>
                            <p>
                                Si ricerca risorsa addetta alla <span class="mark">gestione commerciale</span> dei
                                clienti e dei contatti nella
                                fase di pre-vendita e post-vendita.<br><br>

                                A seguito di una debita formazione volta alla conoscenza del range di offerta Page93®
                                sarà costituito un team commerciale.<br><br>

                            </p>
                        </div>

                        <div class="column is-12 circleWorkImageContainer">
                            <img src="@/assets/images/icons/circleWork.png" class="circleWork">
                        </div>
                        <div class="column is-4 is-offset-1">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/winIcon.png"
                                    width="35px" class="iconInfo">Perchè con page93®</h3>
                            <p>La ricerca è finalizzata all’inserimento a tempo <span class="mark">indeterminato</span>
                                mentre l’inquadramento
                                proposto sarà commisurato alle competenze ed all’esperienza della risorsa.<br><br>

                                Orario di lavoro <span class="mark">flessibile</span><br>
                                Corsi di <span class="mark">formazione</span> continua<br>
                                Possibilità di <span class="mark">crescita</span> all’interno di page93®<br>
                                <span class="mark">Benefit</span> da concordare ad hoc<br><br>
                            </p>
                        </div>
                        <div class="column is-4 is-offset-2">
                            <h3 class="is-uppercase workSubTitle"><img src="@/assets/images/icons/workIcon.png"
                                    width="35px" class="iconInfo">Sede di lavoro</h3>
                            <p>
                                La sede di lavoro è situata in<br>
                                Corso Piera Cillario 6/8 – <span class="mark">Alba</span> (CN) – 12051<br><br>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'WorkWithUs',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .WorkWithUs {
        width: 100%;

        .peopleIcon {
            position: absolute;
            right: 20px;
            bottom: -80px;
            height: 230px;
            z-index: 1;

            @media only screen and (max-width: 768px) {
                display: none;
            }
        }

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            &.blackBg {
                background-color: #000000;
                color: #ffffff;
                min-height: 40vh;
            }

            .infoContainer {
                display: flex;
                // height: 100%;
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 400;
                text-align: left;
                text-align: justify;

                @media only screen and (min-width: 768px) {
                    margin-right: 30px;
                    margin-top: 60px;
                }
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {

                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }

            .mark {
                color: #eb222b;
            }

            .workContainer {

                .bRed {
                    color: #eb222b;
                    font-weight: 900;
                    font-size: 34px;
                    display: block;
                    text-align: center;
                    position: relative;

                    span {
                        background-color: #000;
                        z-index: 2;
                        position: relative;
                        padding-left: 15px;
                        padding-right: 15px;
                    }

                    @media only screen and (min-width: 768px) {
                        &:after {
                            content: ' ';
                            position: absolute;
                            width: 100%;
                            background-color: #fff;
                            height: 5px;
                            left: 0;
                            bottom: calc(50%);
                            z-index: 1 !important;
                        }
                    }
                }

                .workSubTitle {
                    font-weight: 900;
                    margin-bottom: 20px;
                }

                .iconInfo {
                    margin-right: 15px;
                }

                .circleWorkImageContainer {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 50px;
                }

                .circleWork {
                    display: block;
                    text-align: center;
                    height: 250px;
                }
            }
        }
    }
</style>